/**
 * Helper functions for email signature generator
 */

/**
 * Analyzes a value to determine the appropriate link type and format
 * @param {string} value - The value to analyze (email, phone, url, etc.)
 * @param {string} label - The label associated with the value (used as secondary hint)
 * @returns {Object} An object with href and type properties
 */
export const getLink = (value, label) => {
    if (!value) return { href: '#', type: 'text' };

    const lowerValue = value.toLowerCase().trim();
    const lowerLabel = (label || '').toLowerCase().trim();

    // 1. EMAIL DETECTION - İÇERİK KONTROLÜ
    // Check for email format (something@something.something)
    if (lowerValue.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/)) {
        return {
            href: `mailto:${value}`,
            type: 'email'
        };
    }

    // 2. WEBSITE DETECTION - İÇERİK KONTROLÜ
    // Check for URL patterns
    if (
        lowerValue.startsWith('http://') ||
        lowerValue.startsWith('https://') ||
        lowerValue.startsWith('www.') ||
        // Domain name pattern (example.com)
        lowerValue.match(/^[a-z0-9][-a-z0-9]*\.[a-z0-9][-a-z0-9]*(\.[a-z0-9][-a-z0-9]*)*$/)
    ) {
        let href = value;
        if (!href.startsWith('http')) {
            href = `https://${href}`;
        }
        return {
            href,
            type: 'website'
        };
    }

    // 3. PHONE DETECTION - İÇERİK KONTROLÜ
    // Check for phone number patterns
    if (
        // Basic phone format check - allow numbers, plus, parens, dashes
        lowerValue.match(/^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/) &&
        // Must have at least 5 digits total
        lowerValue.replace(/[^0-9]/g, '').length >= 5
    ) {
        return {
            href: `tel:${value.replace(/\s+/g, '')}`,
            type: 'phone'
        };
    }

    // 4. LABEL BASED DETECTION - ETİKET KONTROLÜ (SADECE İÇERİK TANIMA BAŞARISIZ OLURSA)
    // Only use label as a fallback if content analysis was inconclusive

    // If it looks like a phone number label but wasn't detected as a phone
    // And value contains at least one digit, treat as phone
    if (
        (
            lowerLabel === 'phone' ||
            lowerLabel === 'telephone' ||
            lowerLabel === 'tel' ||
            lowerLabel === 'cell' ||
            lowerLabel === 'mobile' ||
            lowerLabel === 'fax' ||
            lowerLabel.includes('phone') ||
            lowerLabel.includes('mobile') ||
            lowerLabel.includes('cell')
        ) &&
        lowerValue.match(/[0-9]/) // Has at least one digit
    ) {
        return {
            href: `tel:${value.replace(/\s+/g, '')}`,
            type: 'phone'
        };
    }

    // Default: just show as text
    return {
        href: '#',
        type: 'text'
    };
};

/**
 * Escapes the characters that would otherwise break out of HTML text or attribute context
 * @param {*} value - The value to escape (nullish values become an empty string)
 * @returns {string} HTML safe representation of the value
 */
export const escapeHtml = (value) =>
    String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
